
// export { default as Dashboard } from './dashboard';
// export { default as Insurance } from './insurance';
// export { default as Tax } from './tax';
// export { default as Booking } from './booking';
// export { default as AdminProfile } from './admin-profile';
// export { default as Accounts } from './accounts';
// export { default as Vehicles } from './vehicles';
import { lazy } from 'react';

export const Dashboard = lazy(() => import('./dashboard'));
export const Insurance = lazy(() => import('./insurance'));
export const Tax = lazy(() => import('./tax'));
export const Booking = lazy(() => import('./booking'));
export const AdminProfile = lazy(() => import('./admin-profile'));
export const Accounts = lazy(() => import('./accounts'));
export const Vehicles = lazy(() => import('./vehicles'));
export const Agents = lazy(() => import('./agents'));
export const Users = lazy(() => import('./users'));
export const Checkout = lazy(() => import('./checkout'));
export const CheckoutDetail = lazy(() => import('./checkoutDetail'));